import script from "./Switcher.vue?vue&type=script&setup=true&lang=js"
export * from "./Switcher.vue?vue&type=script&setup=true&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=4b4a2eea&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4a2eea"]])

export default __exports__